module.exports = __webpack_public_path__ + "img/g.1c1ab3bd.jpg";